import React from "react";
import {
  Button,
  EmptyModal,
  Select,
  TableWithHeader,
} from "../../../../components/core";
import { useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";

export default function IdStatusHistoryModal({ isOpen, onClose, item }) {
  const statusHistory = useSelector(
    (state) => state.agentProfile.verifiedStatusHistory
  );
  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      className="max-w-[95%] md:w-[950px]"
      draggable={false}
      resizable={false}
    >
      <TableWithHeader
        showHeader={false}
        header={[
          { header_name: "Verified Status", key: "verifiedStatus" },
          { header_name: "Msg to Agent", key: "agentStatusComments" },
          { header_name: "Private Comments", key: "comments" },
          { header_name: "Status Date", key: "createdAt" },
        ]}
        item={statusHistory}
        itemsPerPage={3}
        withLink={false}
      ></TableWithHeader>
      {/* <hr className="my-6"></hr>
      <Button className={"p-2"} value={"Close"} onClick={onClose} /> */}
    </Dialog>
  );
}
